import { render } from "./EditarFicherosPerfil.vue?vue&type=template&id=7b91d665"
import script from "./EditarFicherosPerfil.vue?vue&type=script&lang=js"
export * from "./EditarFicherosPerfil.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__